import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Role } from "../../models/RoleModel";

// src/features/auth/authSlice.ts

interface UIControlState {
  loading: boolean;
}

const initialState: UIControlState = {
  loading: false,
};

export const uiControlSlice = createSlice({
  name: "uiControl",
  initialState,
  reducers: {
    beginLoading(state) {
      state.loading = true;
    },
    endLoading(state) {
      state.loading = false;
    },
  },
});

export const { beginLoading, endLoading } = uiControlSlice.actions;
export default uiControlSlice.reducer;
